import { createSelector } from 'reselect';

export const commonSelector = state => state.common;

export const globalLoadingSelector = createSelector(
  commonSelector,
  common => common.globalLoading,
);
